shadow$provide[344] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Memo:{enumerable:true, get:function() {
  return Memo;
}}});
var require$three = require("three");
var require$_DOT__SLASH_rendertotexture_DOT_js = require("./rendertotexture.js");
class Memo extends require$_DOT__SLASH_rendertotexture_DOT_js.RenderToTexture {
  constructor(renderer, shaders, options) {
    let _height, _width;
    const items = options.items || 1;
    const channels = options.channels || 4;
    const width = options.width || 1;
    const height = options.height || 1;
    const depth = options.depth || 1;
    options.format = require$three.RGBAFormat;
    options.width = _width = items * width;
    options.height = _height = height * depth;
    options.frames = 1;
    delete options.items;
    delete options.depth;
    delete options.channels;
    super(renderer, shaders, options);
    if (this.items == null) {
      this.items = items;
    }
    if (this.channels == null) {
      this.channels = channels;
    }
    if (this.width == null) {
      this.width = width;
    }
    this._width = _width;
    if (this.height == null) {
      this.height = height;
    }
    this._height = _height;
    if (this.depth == null) {
      this.depth = depth;
    }
    this._adopt({textureItems:{type:"f", value:this.items}, textureHeight:{type:"f", value:this.height},});
  }
  shaderAbsolute(shader) {
    if (shader == null) {
      shader = this.shaders.shader();
    }
    shader.pipe("map.xyzw.texture", this.uniforms);
    return super.shaderAbsolute(shader, 1, 2);
  }
}

};